import { Link } from 'react-router-dom';
import { CalendarHeart } from 'lucide-react';

export function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2.5 group">
      <div className="w-10 h-10 rounded-lg forest-gradient flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow">
        <CalendarHeart className="w-5 h-5 text-cream" />
      </div>
      <span className="font-heading text-xl font-semibold text-primary">
        Wedding Timeline<span className="text-champagne">Hub</span>
      </span>
    </Link>
  );
}